<template>
  <v-list dense class="transparent" v-if="questionList.length > 0">
    <v-subheader
      ><strong>{{ group.name }}</strong></v-subheader
    >
    <filter-list v-for="question in questionList" :question="question" :key="question.id" class="pl-1"></filter-list>
  </v-list>
</template>

<script>
import _ from 'lodash';
import { mapGetters } from 'vuex';
import FilterList from './FilterList';

export default {
  components: {
    FilterList
  },
  name: 'filter-group-list',
  data: () => ({
    questionTypes: ['currency', 'radio', 'select']
  }),
  props: ['group'],
  computed: {
    ...mapGetters(['UserHasRole']),
    questionList: function() {
      let questions = _.orderBy(
        _.filter(
          this.group.questions,
          question =>
            question.enabled === true &&
            (question.questionType.name === 'select' ||
              question.questionType.name === 'radio' ||
              question.questionType.name === 'currency')
        ),
        'pivot.sort_order'
      );
      if (this.UserHasRole('Property Broker')) {
        questions = _.filter(questions, question => question.is_critical !== true);
      }
      return questions;
    }
  }
};
</script>

<style scoped lang="scss">
::v-deep .list__tile {
  height: auto !important;
  user-select: unset;
}

::v-deep .list__tile__content {
  /*overflow: auto;*/
}

::v-deep .input-group {
  /*padding-top: 0;*/

  label {
    font-size: 13px;
  }

  .input-group__details::before {
    height: 0;
  }
}
</style>
